import { useUser } from "../../contexts/UserContext";
import { User } from "../../models/User";
import { useState } from "react";
import { Table, TableBody, TableCell, TableRow } from "../../design/table";
import { Button } from "../../design/button";
import SelectUserDialog from "../Dialogs/SelectUserDialog/SelectUserDialog";
import { PlusIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Field } from "@headlessui/react";
import { Label } from "../../design/fieldset";
import { useMatter } from "../../contexts/MatterContext";

interface SelectUserDialogProps {
  title?: string;
  values: User["_id"][];
  onChange: (value: User["_id"][]) => void;
}

const SelectUsersField: React.FC<SelectUserDialogProps> = ({
  title,
  values,
  onChange,
}) => {
  const { currentMatter } = useMatter();
  const [showUserDialog, setShowUserDialog] = useState(false);
  const users = currentMatter?.users || [];

  const onUserSelected = (user: User) => {
    if (!values.includes(user._id)) {
      onChange([...values, user._id]);
    } else {
      onChange(values.filter((id) => id !== user._id));
    }
    setShowUserDialog(false);
  };

  const removeUser = (id: string) => {
    onChange(values.filter((pid) => pid !== id));
  };

  const selectedUsers = users.filter((p) => values.includes(p._id));

  return (
    <Field>
      <div className="flex items-center justify-between mb-2">
        <Label>{title}</Label>
        <Button onClick={() => setShowUserDialog(true)}>
          <PlusIcon className="w-5 h-5 mr-2" />
        </Button>
      </div>

      <SelectUserDialog
        isOpen={showUserDialog}
        onClose={() => setShowUserDialog(false)}
        onUserSelected={onUserSelected}
      />

      <div className="overflow-hidden border rounded-lg">
        <Table>
          <TableBody>
            {selectedUsers.length > 0 ? (
              selectedUsers.map((user) => (
                <TableRow key={user._id}>
                  <TableCell>{user.name}</TableCell>
                  <TableCell className="text-right">
                    <Button color="red" onClick={() => removeUser(user._id)}>
                      <XMarkIcon className="w-5 h-5" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2} className="text-center text-gray-500">
                  No users selected
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Field>
  );
};

export default SelectUsersField;
